import React, { useEffect, useMemo, useRef, useState } from 'react';
import { observer } from "mobx-react-lite";
import { useLockFn, useMemoizedFn, useRequest } from "ahooks";
import { useMobx } from "@/utils/hooks";
import { $ajax, conf, joinAndFinish, mydj } from "@/utils/request";
import { Tooltip } from 'nicetoolfn';
import { ConfDoData, ConfDoEntrys, ConfDoEntrysTasks, GameRecord, Mydj, Res } from '@/interface/request.interface'

import Button from "@/views/component/public/button";
import { View, ToolRule } from "@/views/component/dayFree/style";
import { catchModal, getDayEndTime, playGame, random, statClick } from "@/utils/util";
import { EButton, EModal } from "@/interface/enum";
import { Award, AwardIntegral, Modal } from "@/views/component/modal";

let _apiStore: TApiStore

type TApiStore = {
  expiration: Date // f2eGame.util.formaDate(getDayEndTime(), "yyyy-MM-dd hh:mm:ss")
  selectGameIdx: number,
  selectGame: ConfDoEntrys['upgs'],
  selectAwardIdx?: number,
}

function getApiStore() {
  return $ajax<{ pval: string } | null>(`//gxhdgame.yy.com/shopmall/get.do`, {
    data: {
      actCode: CONFIG.code.YYVIP2023_free_exchange,
      type: 'wxAwards'
    },
    dataType: 'jsonp'
  })
}

function setApiStore(data: TApiStore) {
  _apiStore = data;
  return $ajax(`//gxhdgame.yy.com/shopmall/addOrUpdate.do`, {
    data: {
      actCode: CONFIG.code.YYVIP2023_free_exchange,
      type: 'wxAwards',
      awards: JSON.stringify(data),
    },
    dataType: 'jsonp'
  })
}

function Index() {
  const store = useMobx('store');
  const operate = useMobx('operate');

  // 模块任务状态
  const [already, triggerAlready] = useState(false);
  const [isFinishDayFreeTask, triggerIsFinishDayFreeTask] = useState(false);
  const [isGetMydjRemain, triggerMyDjRemain] = useState(false);
  /** *************************************************/
  const { runAsync: YYVIP2023_free_01 } = useRequest<ConfDoData, any>(conf(CONFIG.code.YYVIP2023_free_01), { manual: true });
  const { runAsync: YYVIP2022_free_exchange } = useRequest<ConfDoData, any>(conf(CONFIG.code.YYVIP2022_free_exchange), { manual: true });
  const { runAsync: commitAward } = useRequest(joinAndFinish, {
    manual: true,
    onSuccess: (data, params) => {
      const { taskId } = params[0];
      const idx = operate.dayFreeAward.findIndex((item: ConfDoEntrysTasks) => item.id === taskId)
      const { awardImg, name } = CONFIG.everyDayFree.award[idx];

      $refPopup.current.open(
        <Modal modalType={EModal['恭喜获得']}>
          <Award name={name} integral={CONFIG.everyDayFree.integral} awardImg={awardImg} integralImg={CONFIG.everyDayFree.integralImg}/>
        </Modal>
      );

      setTimeout(() => init(), 2000);
    },
    onError: (error) => {
      const res: Res = JSON.parse(error.message);
      catchModal(EModal['提示'], { message: res.message });
    },
    onFinally() {
      setTimeout(() => init(), 2000)
    }
  });
  /** *************************************************/


  const _commitAward = async function () {
    const awardIdx = operate.checkAwardIdx;

    const taskId = operate.dayFreeAward[awardIdx].id;
    const curGame = operate.randomEntryGame;

    await commitAward({
      actCode: CONFIG.code.YYVIP2022_free_exchange,
      taskId,
      serverId: curGame.serverId,
      gameId: curGame.gameId
    })
  }
  // 领取奖励
  const { runAsync: getAward } = useRequest(joinAndFinish, {
    manual: true,
    onSuccess: (data, params) => {
      const taskIdx = operate.dayFreeTask.findIndex((item: ConfDoEntrysTasks) => item.taskStatus !== 100);

      if (store.noParticipate) {
        store.updateParticipate();
        statClick();
      }
      statClick(`bx${taskIdx + 1}`, `每日免费奖励${taskIdx + 1}`);

      // 表示未获得奖品
      if (data.awards.some((item) => item.awardName === '谢谢参与')) {
        const data = CONFIG.everyDayFree.probability[taskIdx + 1];
        const msg = CONFIG.everyDayFree.noGetAwardTip.replace('<%>', data);
        return $refPopup.current.open(<Modal modalType={EModal['提示']} btnType={EButton['弹窗-好的']} message={msg}/>);
      }

      // 未选择奖品
      if (operate.checkAwardIdx === undefined) {
        return $refPopup.current.open(<Modal modalType={EModal['提示']} message={CONFIG.everyDayFree.noSelectAwardTip}/>);
      }

      if( !already ) {
        _commitAward();
      } else {
        $refPopup.current.open(
          <Modal modalType={EModal['恭喜获得']}>
            <AwardIntegral integral={CONFIG.everyDayFree.integral} integralImg={CONFIG.everyDayFree.integralImg}/>
          </Modal>
        );
      }

      setTimeout(() => {
        operate.initMonthRecharge();
      }, 1500);
    },
    onError: (error) => {
      const res: Res = JSON.parse(error.message);

      // 任务未完成
      if (res.status === 411) {
        return catchModal(EModal['提示'], {
          message: res.message,
          btnType: EButton['弹窗-回到游戏'],
          confirmFn: (props: any) => {
            // 进入游戏
            enterGame();
            props.clearAll();
          }
        });
      }

      catchModal(EModal['提示'], { message: res.message });
    },
    onFinally() {
      setTimeout(() => init(), 2000)
    }
  });
  // 是否为VIP用户
  const { runAsync: isVipUser } = useRequest(() => $ajax<boolean>(`//gxhdgame.yy.com/yyvip/isvip.do`), {
    manual: true
  });
  // 是否已获得积分
  const { runAsync: getMydjVerify } = useRequest<Mydj, any>(mydj(CONFIG.code.act_dayFreeVerify), { manual: true });

  const init = async () => {
    const [free01, exchange, apiStore, mydjVerify] = await Promise.all([
      YYVIP2023_free_01(),
      YYVIP2022_free_exchange(),
      getApiStore(),
      getMydjVerify()
    ]);
    console.log('apiStore', apiStore);

    const taskList = free01.entrys[0].tasks;
    // 游戏入口
    const entryList = free01.entrys.map((item) => item.upgs);
    // 奖励
    const awards = exchange.entrys[0].tasks;

    // 是否已经领取奖励
    if (awards.some((item) => item.taskStatus === 100)) {
      triggerAlready(true);
    }
    // 是否已获得奖励积分
    if (mydjVerify.remain !== 0) {
      triggerMyDjRemain(true);
    }

    operate.setDayFreeTask(taskList);
    operate.setDayFreeGameEntry(entryList);
    operate.setDayFreeAward(awards);

    initDefaultStore();

    function initDefaultStore() {
      // 未选择奖励&&游戏入口
      if (apiStore == null || apiStore.pval === '') {
        const gameEntryIdx = random(entryList.length);
        operate.setRandomEntryGameIdx(gameEntryIdx);
        operate.setRandomEntryGame(entryList[gameEntryIdx])
        return setApiStore({
          expiration: f2eGame.util.formaDate(getDayEndTime(), "yyyy-MM-dd hh:mm:ss"),
          selectGame: entryList[gameEntryIdx],
          selectGameIdx: gameEntryIdx
        })
      }

      const pval: TApiStore = JSON.parse(apiStore.pval);
      // 重新发版,重置已出现bug用户的数据信息;
      const isBug = Object.keys(pval).length === 1;
      const isExpiration = new Date().getTime() > new Date(pval.expiration).getTime();

      if (isExpiration || isBug) {
        const gameEntryIdx = random(entryList.length);
        operate.setRandomEntryGameIdx(gameEntryIdx);
        operate.setRandomEntryGame(entryList[gameEntryIdx])
        return setApiStore({
          expiration: f2eGame.util.formaDate(getDayEndTime(), "yyyy-MM-dd hh:mm:ss"),
          selectGame: entryList[gameEntryIdx],
          selectGameIdx: gameEntryIdx
        })
      }

      _apiStore = pval;

      if (pval.selectAwardIdx !== undefined) {
        operate.setCheckAwardIdx(pval.selectAwardIdx);
      }
      operate.setRandomEntryGame(pval.selectGame);
      operate.setRandomEntryGameIdx(pval.selectGameIdx);
    }
  }
  const handleCheckedAward = useLockFn(async (index: 0 | 1 | 2) => {
    if (operate.checkAwardIdx === index) {
      return;
    }

    // 处理网络性问题: 如果接口太慢,用户直接调用此方法,会导致get.do的数据错乱
    if (_apiStore === undefined) {
      return;
    }

    if(CONFIG.everyDayFree.award[index].lessThan) {
      return $refPopup.current.open(<Modal modalType={EModal['提示']} message={'该奖品暂无库存，请选择其他奖品'}/>);
    }

    if (CONFIG.everyDayFree.award[index].verifyVIP) {
      const isVip = await isVipUser();
      if (isVip === false) {
        return $refPopup.current.open(<Modal modalType={EModal['提示']} message={'该奖品需要YY会员激活，请选择其他奖品'}/>);
      }
    }

    setApiStore({
      ...(_apiStore || {}),
      selectAwardIdx: index
    })
    operate.setCheckAwardIdx(index);
  });

  const enterGame = () => {
    const gameIdx = operate.randomEntryGameIdx;
    const curGame = operate.randomEntryGame;
    playGame(curGame.gameId, curGame.serverId, gameIdx);
  }

  useEffect(() => {
    init();
  }, []);

  const taskName = useMemo(() => {
    if (operate.randomEntryGameIdx === undefined) {
      return '';
    }

    const gameIdx = operate.randomEntryGameIdx;

    let curTaskIdx;
    if (operate.dayFreeTask.every((item: ConfDoEntrysTasks) => item.taskStatus === 100)) {
      curTaskIdx = 2;
      triggerIsFinishDayFreeTask(true);
    } else if (operate.dayFreeTask.every((item: ConfDoEntrysTasks) => item.taskStatus !== 100)) {
      curTaskIdx = 0;
    } else {
      curTaskIdx = operate.dayFreeTask.findIndex((item: ConfDoEntrysTasks) => item.taskStatus !== 100);
      if (isGetMydjRemain) {
        curTaskIdx--;
      }
      // if (already) {
      //   curTaskIdx--;
      // } else if (isGetMydjRemain) {
      //   curTaskIdx--;
      // }
    }
    const task = operate.dayFreeTask[curTaskIdx];
    const name = task.name.replace('{}', task.showName);

    return `${name} (${curTaskIdx + 1}/3)`;
  }, [operate.randomEntryGameIdx, operate.dayFreeTask, already, isFinishDayFreeTask])

  const handleGetAward = useLockFn(async () => {
    if (isGetMydjRemain) {
      // 未选择奖品
      if (operate.checkAwardIdx === undefined) {
        return $refPopup.current.open(<Modal modalType={EModal['提示']} message={CONFIG.everyDayFree.noSelectAwardTip}/>);
      }
      return _commitAward();
    }

    const curTask = operate.dayFreeTask.find((item: ConfDoEntrysTasks) => item.taskStatus !== 100);
    const curGame = operate.randomEntryGame;

    if (curTask.taskStatus === 0) {
      // 进入游戏
      enterGame();
    }
    await getAward({
      actCode: CONFIG.code.YYVIP2023_free_01,
      taskId: curTask.id,
      serverId: curGame.serverId,
      gameId: curGame.gameId
    })
  })

  return <View>
    <p className='probabilityTip' dangerouslySetInnerHTML={({ __html: CONFIG.everyDayFree.probabilityTip })}></p>
    <p className='taskName'>{taskName}</p>
    <p className='tipTxt'>请选择一个活动奖品
      <Tooltip popup={<ToolRule/>} trigger={'mouse'}>
        <span>?</span>
      </Tooltip>
    </p>
    <ul>
      {CONFIG.everyDayFree.award.map((item: any, index: any) => {
        const style = operate.checkAwardIdx === index ? 'active' : '';
        return <li className={style} onClick={() => !already && handleCheckedAward(index)} key={index}>
          <img src={item.awardImg} alt=""/>
          <p>{item.name}</p>
        </li>
      })}
    </ul>
    <Button type={EButton['每日免费-领取']}
        status={isFinishDayFreeTask && already ? 100 : 0}
        onClick={() => isFinishDayFreeTask && already ? null : handleGetAward()}
    />
  </View>
}

export default observer(Index);
